import { Button, SwitchDefault } from '@components/index'
import { USER_ROLE } from '@interfaces/userManagement/enums/userRole'
import { USER_STATUS } from '@interfaces/userManagement/enums/userStatus'
import { IUserManagement } from '@interfaces/userManagement/IUserManagement'
import { errorHandler } from '@services/index'
import UserManagementService from '@services/requests/userManagementService'
import React from 'react'
import { toast } from 'react-toastify'

interface IProps {
    item: IUserManagement
}

export default function ToggleUserStatusCell(props: IProps): React.ReactElement {
    const { item } = props

    function userStatusToBoolean(status: USER_STATUS): boolean {
        return status === USER_STATUS.ACTIVE
    }

    const [status, setStatus] = React.useState<USER_STATUS>(item.status)
    const [checked, setChecked] = React.useState(userStatusToBoolean(status))
    const [isDisabledSwitch, setIsDisabledSwitch] = React.useState(false)
    const [isLoading, setIsLoading] = React.useState(false)

    React.useEffect(() => {
        setChecked(userStatusToBoolean(status))
    }, [status])

    async function updateUserStatusHandler(id: number, active: boolean, role: USER_ROLE): Promise<void> {
        setIsDisabledSwitch(true)
        setIsLoading(true)
        try {
            const activeStatus = active ? USER_STATUS.ACTIVE : USER_STATUS.INACTIVE
            const response = await UserManagementService.activeUnactiveUser(id, activeStatus, role)

            toast(response.message, { type: 'success' })
            setStatus(activeStatus)
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsDisabledSwitch(false)
            setIsLoading(false)
        }
    }

    return (
        <div className='box-action-switch'>
            {status === USER_STATUS.AWAITING ? (
                <div className="buttons-cell">
                    <Button
                        placeholder="Aprovar"
                        onClick={() => updateUserStatusHandler(item.id, true, item.role)}
                        customClasses="btn-small"
                        isLoading={isLoading}
                    />

                    <Button
                        secondary
                        placeholder="Bloquear"
                        onClick={() => updateUserStatusHandler(item.id, false, item.role)}
                        customClasses="btn-small"
                        isLoading={isLoading}
                    />
                </div>
            ) : (
                <>
                    <SwitchDefault
                        onChange={(event) => updateUserStatusHandler(item.id, event.target.checked, item.role)}
                        checked={checked}
                        color='secondary'
                        disabled={isDisabledSwitch}
                        title={'Ativar/Desativar'}
                    />

                    <p className='small-2'>{checked ? 'Ativo' : 'Inativo'}</p>
                </>
            )}

        </div>
    )
}
